// src/pages/ConfirmPassword.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ConfirmPassword() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpdate = async () => {
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      toast.error("Error al cambiar contraseña", {
        description: error.message,
      });
    } else {
      toast.success("Contraseña actualizada", {
        description: "Ya puedes iniciar sesión",
      });
      navigate("/login");
    }

    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-muted">
      <Card className="w-full max-w-md shadow">
        <CardHeader>
          <CardTitle className="text-center text-2xl">
            Nueva contraseña
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Nueva contraseña</Label>
            <Input
              id="password"
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button className="w-full" onClick={handleUpdate} disabled={loading}>
            {loading ? "Actualizando..." : "Cambiar contraseña"}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
